// DDv2.Library
import d2fmt from '@/ddv2.library/utils/formatter'
import d2dt from '@/ddv2.library/utils/datetime'
import indexeddb from '@/ddv2.library/indexeddb'

// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
// import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'

// vue Definition
// import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

// DdComponents アルファベット順記述
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCustomButton = () => import('@/components/DdCustomButton')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSectionTitle = () => import('@/components/DdSectionTitle')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTextBoxPlaceHolderFree = () => import('@/components/DdTextBoxPlaceHolderFree')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'DdHaishaJuchuEditDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    DdCheckbox,
    DdCodeTextBox,
    DdCustomButton,
    DdDataTable,
    DdDateBox,
    DdDropDown,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdNumericBox,
    DdSectionTitle,
    DdTextBox,
    DdTextBoxPlaceHolderFree,
    DdTimeBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * 作業計画情報構造体
     */
    dataSource: Object
  },

  data: () => ({
    invalidMessage: '',
    jissekiKakuteiFlg: false,
    sharyoKbn: '00',
    haisoMeisaiTableHeight: undefined,
    meisaiCount: 0,
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    // パラメータ値用定義
    inputData: {
      haishaYmd: '',
      vwCD2plmd00100: [{}],
      vwCD2plmd00101: [{}],
      vwCD2plmd00102: [{}]
    },
    viewsData: {
      vwCD2plmd00103: {},
      vwCD2plmd00104: {},
      vwCD2plmd00105_1: {},
      vwCD2plmd00105_2: {},
      vwCD2plmd00106: []
    },
    // データテーブル用ヘッダー定義
    haisoMeisaiListHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '受注番号/作業内容', value: 'juchuNo' },
      { text: '顧客', value: 'dispTokuisaki' },
      { text: '発地', value: 'dispHatsuchi' },
      { text: '発地日時', value: 'dispHatsuchiYmdHm' },
      { text: '着地', value: 'dispChakuchi' },
      { text: '着地日時', value: 'dispChakuchiYmdHm' },
      { text: '請求予定日', value: 'seikyuYoteiYmd', align: 'right' },
      { text: '請求運賃', value: 'seikyuKihonUnchin', align: 'right' },
      { text: '請求有料代', value: 'seikyuHiwayPrice', align: 'right' },
      { text: '請求立替金', value: 'seikyuUserKingakuKazei1', align: 'right' },
      { text: '請求貨物保険料', value: 'seikyuUserKingakuKazei2', align: 'right' },
      { text: '運行手当', value: 'sagyoinTeateKingaku1', align: 'right' },
      { text: '奨励手当', value: 'sagyoinTeateKingaku2', align: 'right' },
      { text: '支払予定日', value: 'shiharaiYoteiYmd' },
      { text: '支払運賃', value: 'shiharaiKihonUnchin', align: 'right' },
      { text: '支払有料代', value: 'shiharaiHiwayPrice', align: 'right' },
      { text: '支払立替金', value: 'shiharaiUserKingakuKazei1', align: 'right' },
      { text: '支払貨物保険料', value: 'shiharaiUserKingakuKazei2', align: 'right' }
    ]
  }),

  created () {
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hacchusakiList: 'DDMasters/mstHacchusaki',
      kubunList: 'DDMasters/msysKubun',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      usersEigyosho: 'users/eigyoshoCd'
    }),

    // --------------------------------------------------------------------------------
    // フィルター
    // --------------------------------------------------------------------------------
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    filteredVwcJininList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
    },
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
    },
    filteredShuroKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF999')
    },
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    filteredHaisoMeisaiListRows () {
      // データがない場合の制御
      if (!this.viewsData.vwCD2plmd00106.map) { return }

      this.meisaiCount = this.viewsData.vwCD2plmd00106.length
      if (this.meisaiCount > 10) {
        this.haisoMeisaiTableHeight = 300
      } else {
        this.haisoMeisaiTableHeight = undefined
      }

      return this.viewsData.vwCD2plmd00106.map((elem) => {
        if (elem.tokuisakiId) {
          var mstTokuisaki = indexeddb.getRecord(this.torihikisakiList, elem.tokuisakiId)
          if (mstTokuisaki) {
            elem.dispTokuisaki = mstTokuisaki.torihikisakiCd + ':' + mstTokuisaki.torihikisakiNm
          }
        }
        if (elem.hatsuchiId) {
          var mstHacchakuchi1 = indexeddb.getRecord(this.hacchakuchiList, elem.hatsuchiId)
          if (mstHacchakuchi1) {
            elem.dispHatsuchi = mstHacchakuchi1.hacchakuchiCd + ':' + mstHacchakuchi1.hacchakuchiNm
          }
        }
        if (elem.hatsuchiYmd || elem.hatsuchiHms) {
          elem.dispHatsuchiYmdHm = !elem.hatsuchiYmd ? elem.hatsuchiHms : !elem.hatsuchiHms ? elem.hatsuchiYmd : filter.dateFormatter(elem.hatsuchiYmd) + ' ' + elem.hatsuchiHms
        }
        if (elem.chakuchiId) {
          var mstHacchakuchi2 = indexeddb.getRecord(this.hacchakuchiList, elem.chakuchiId)
          if (mstHacchakuchi2) {
            elem.dispChakuchi = mstHacchakuchi2.hacchakuchiCd + ':' + mstHacchakuchi2.hacchakuchiNm
          }
        }
        if (elem.chakuchiYmd || elem.chakuchiHms) {
          elem.dispChakuchiYmdHm = !elem.chakuchiYmd ? elem.chakuchiHms : !elem.chakuchiHms ? elem.chakuchiYmd : filter.dateFormatter(elem.chakuchiYmd) + ' ' + elem.chakuchiHms
        }
        if (elem.seikyuYoteiYmd) {
          elem.seikyuYoteiYmd = filter.dateFormatter(elem.seikyuYoteiYmd)
        }
        if (elem.seikyuKihonUnchin) {
          elem.seikyuKihonUnchin = filter.numericFormatter(String(elem.seikyuKihonUnchin))
        }
        if (elem.seikyuHiwayPrice) {
          elem.seikyuHiwayPrice = filter.numericFormatter(String(elem.seikyuHiwayPrice))
        }
        if (elem.seikyuUserKingakuKazei1) {
          elem.seikyuUserKingakuKazei1 = filter.numericFormatter(String(elem.seikyuUserKingakuKazei1))
        }
        if (elem.seikyuUserKingakuKazei2) {
          elem.seikyuUserKingakuKazei2 = filter.numericFormatter(String(elem.seikyuUserKingakuKazei2))
        }
        if (elem.sagyoinTeateKingaku1) {
          elem.sagyoinTeateKingaku1 = filter.numericFormatter(String(elem.sagyoinTeateKingaku1))
        }
        if (elem.sagyoinTeateKingaku2) {
          elem.sagyoinTeateKingaku2 = filter.numericFormatter(String(elem.sagyoinTeateKingaku2))
        }
        if (elem.shiharaiYoteiYmd) {
          elem.shiharaiYoteiYmd = filter.dateFormatter(elem.shiharaiYoteiYmd)
        }
        if (elem.shiharaiKihonUnchin) {
          elem.shiharaiKihonUnchin = filter.numericFormatter(String(elem.shiharaiKihonUnchin))
        }
        if (elem.shiharaiHiwayPrice) {
          elem.shiharaiHiwayPrice = filter.numericFormatter(String(elem.shiharaiHiwayPrice))
        }
        if (elem.shiharaiUserKingakuKazei1) {
          elem.shiharaiUserKingakuKazei1 = filter.numericFormatter(String(elem.shiharaiUserKingakuKazei1))
        }
        if (elem.shiharaiUserKingakuKazei2) {
          elem.shiharaiUserKingakuKazei2 = filter.numericFormatter(String(elem.shiharaiUserKingakuKazei2))
        }
        return elem
      // }).filter((t) => {
      //   return t.trJuchuKihonId !== null
      })
    },
    // --------------------------------------------------------------------------------
    // 車両備考
    // --------------------------------------------------------------------------------
    sharyoBiko () {
      if (this.sharyoKbn === '01') {
        return '自社車両'
      } else if (this.sharyoKbn === '03') {
        return '傭車車両'
      } else {
        return 'その他車両'
      }
    },
    // --------------------------------------------------------------------------------
    // 確定済識別
    // --------------------------------------------------------------------------------
    isConfirmed () {
      return this.jissekiKakuteiFlg
    },

    // --------------------------------------------------------------------------------
    // 合計算出
    // --------------------------------------------------------------------------------
    seikyuKihonUnchinTotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.seikyuKihonUnchin)) ? parseInt(d2fmt.removeComma(m.seikyuKihonUnchin), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    seikyuHiwayPriceTotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.seikyuHiwayPrice)) ? parseInt(d2fmt.removeComma(m.seikyuHiwayPrice), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    seikyuUserKingakuKazei1TotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.seikyuUserKingakuKazei1)) ? parseInt(d2fmt.removeComma(m.seikyuUserKingakuKazei1), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    seikyuUserKingakuKazei2TotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.seikyuUserKingakuKazei2)) ? parseInt(d2fmt.removeComma(m.seikyuUserKingakuKazei2), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    sagyoinTeateKingaku1TotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.sagyoinTeateKingaku1)) ? parseInt(d2fmt.removeComma(m.sagyoinTeateKingaku1), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    sagyoinTeateKingaku2TotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.sagyoinTeateKingaku2)) ? parseInt(d2fmt.removeComma(m.sagyoinTeateKingaku2), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    shiharaiKihonUnchinTotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.shiharaiKihonUnchin)) ? parseInt(d2fmt.removeComma(m.shiharaiKihonUnchin), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    shiharaiHiwayPriceTotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.shiharaiHiwayPrice)) ? parseInt(d2fmt.removeComma(m.shiharaiHiwayPrice), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    shiharaiUserKingakuKazei1TotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.shiharaiUserKingakuKazei1)) ? parseInt(d2fmt.removeComma(m.shiharaiUserKingakuKazei1), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    },
    shiharaiUserKingakuKazei2TotalAmount () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmound = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        return window.isFinite(d2fmt.removeComma(m.shiharaiUserKingakuKazei2)) ? parseInt(d2fmt.removeComma(m.shiharaiUserKingakuKazei2), 10) : 0
      }).forEach(x => {
        totalAmound += x
      })

      return filter.numericFormatter(totalAmound)
    }
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    fetchData: function () {
      var self = this
      return new Promise((resolve) => {
        self.HttpClient
          .post('/api/v1/VwCD2plmd00103/Search', self.viewsData)
          .then((data) => {
            // /* eslint no-debugger: "warn" */
            // debugger
            // ==================================================
            // 運行実績情報
            // ==================================================-
            if (data.payload.vwCD2Plmd00104) {
              self.viewsData.vwCD2plmd00104 = Object.assign({}, data.payload.vwCD2Plmd00104)
              self.viewsData.vwCD2plmd00104.unkoYmd = filter.dateFormatter(this.viewsData.vwCD2plmd00104.unkoYmd)
              // 更新情報
              self.viewsData.vwCD2plmd00104.insDateTime = filter.dateYmdHmsFormatter(this.viewsData.vwCD2plmd00104.insDate)
              var iUser = indexeddb.getRecord(this.eigyoshoJininList, self.viewsData.vwCD2plmd00104.insUserId)
              if (iUser) {
                self.viewsData.vwCD2plmd00104.insUserCdNm = iUser.jininCd + ':' + iUser.jininNmSei
              }
              self.viewsData.vwCD2plmd00104.updDateTime = filter.dateYmdHmsFormatter(this.viewsData.vwCD2plmd00104.updDate)
              var uUser = indexeddb.getRecord(this.eigyoshoJininList, self.viewsData.vwCD2plmd00104.updUserId)
              if (uUser) {
                self.viewsData.vwCD2plmd00104.updUserCdNm = uUser.jininCd + ':' + uUser.jininNmSei
              }
            } else {
              self.viewsData.vwCD2plmd00104.id = -1
            }
            if (data.payload.vwCD2Plmd00105_1) {
              self.viewsData.vwCD2plmd00105_1 = Object.assign({}, data.payload.vwCD2Plmd00105_1)
            }
            if (data.payload.vwCD2Plmd00105_2) {
              self.viewsData.vwCD2plmd00105_2 = Object.assign({}, data.payload.vwCD2Plmd00105_2)
            }
            if (data.payload.vwCD2Plmd00106) {
              self.viewsData.vwCD2plmd00106 = data.payload.vwCD2Plmd00106
            }
            resolve()
          })
      })
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      // データバインド初期化
      this.jissekiKakuteiFlg = false
      this.viewsData.vwCD2plmd00104 = {}
      this.viewsData.vwCD2plmd00105_1 = {}
      this.$set(this.viewsData.vwCD2plmd00105_1, 'jininId', '')
      this.$set(this.viewsData.vwCD2plmd00105_1, 'kosokuJikan', '')
      this.viewsData.vwCD2plmd00105_2 = {}
      this.$set(this.viewsData.vwCD2plmd00105_2, 'jininId', '')
      this.$set(this.viewsData.vwCD2plmd00105_2, 'kosokuJikan', '')
      this.viewsData.vwCD2plmd00106 = []

      if ((this.dataSource.vwCD2plmd00100) && this.dataSource.vwCD2plmd00100 !== null) {
        this.inputData = this.dataSource

        if (this.inputData.vwCD2plmd00100[0].id) {
          this.viewsData.id = this.inputData.vwCD2plmd00100[0].id
          // 運行実績No取得
          this.fetchData().then(() => {
            // /* eslint no-debugger: "warn" */
            // debugger
            if (this.viewsData.vwCD2plmd00104.id < 0) {
              this.viewsData.vwCD2plmd00104.insUserId = this.inputData.vwCD2plmd00100[0].trSagyoKeikakuKihonUpdUserId
              this.viewsData.vwCD2plmd00104.sagyoJissekiEigyoshoId = this.inputData.vwCD2plmd00100[0].eigyoshoId
              this.$refs.unkoYmd.onCalendarInput(this.inputData.haishaYmd)
            } else {
              this.jissekiKakuteiFlg = this.viewsData.vwCD2plmd00104.jissekiKakuninZumiFlg
            }
            // this.viewsData.vwCD2plmd00104.unkoYmd = filter.dateFormatter(this.inputData.vwCD2plmd00100[0].sagyoYoteiYmd)
            var jissekiShukkoYmdHms = ''
            var jissekiShukkoYmd = ''
            var jissekiShukkoHms = ''
            var jissekiKikoYmdHms = ''
            var jissekiKikoYmd = ''
            var jissekiKikoHms = ''
            if (Array.isArray(this.inputData.vwCD2plmd00101)) {
              this.inputData.vwCD2plmd00101.forEach(function (item) {
                var shukkoYmdHms = item.hatsuchiYmd + item.hatsuchiHms
                if (jissekiShukkoYmdHms === '' || jissekiShukkoYmdHms > shukkoYmdHms) {
                  jissekiShukkoYmdHms = shukkoYmdHms
                  jissekiShukkoYmd = item.hatsuchiYmd
                  jissekiShukkoHms = item.hatsuchiHms
                }
                var kikoYmdHms = item.chakuchiYmd + item.chakuchiHms
                if (jissekiKikoYmdHms === '' || jissekiKikoYmdHms < kikoYmdHms) {
                  jissekiKikoYmdHms = kikoYmdHms
                  jissekiKikoYmd = item.chakuchiYmd
                  jissekiKikoHms = item.chakuchiHms
                }
              })
            }
            if (Array.isArray(this.inputData.vwCD2plmd00102)) {
              this.inputData.vwCD2plmd00102.forEach(function (item) {
                var startYmdHms = item.startYmd + item.startHms
                if (jissekiShukkoYmdHms === '' || jissekiShukkoYmdHms > startYmdHms) {
                  jissekiShukkoYmdHms = startYmdHms
                  jissekiShukkoYmd = item.startYmd
                  jissekiShukkoHms = item.startHms
                }
                var endYmdHms = item.endYmd + item.endHms
                if (jissekiKikoYmdHms === '' || jissekiKikoYmdHms < endYmdHms) {
                  jissekiKikoYmdHms = endYmdHms
                  jissekiKikoYmd = item.endYmd
                  jissekiKikoHms = item.endHms
                }
              })
            }

            if (this.viewsData.vwCD2plmd00104.id < 0) {
              this.$refs.jissekiShukkoYmd.onCalendarInput(filter.dateFormatter(jissekiShukkoYmd))
              this.$set(this.viewsData.vwCD2plmd00104, 'jissekiShukkoHms', jissekiShukkoHms)
              this.$refs.jissekiKikoYmd.onCalendarInput(filter.dateFormatter(jissekiKikoYmd))
              this.$set(this.viewsData.vwCD2plmd00104, 'jissekiKikoHms', jissekiKikoHms)
              this.viewsData.vwCD2plmd00105_1.jininId = this.inputData.vwCD2plmd00100[0].jomuinId

              if (this.inputData.vwCD2plmd00100[0].dojoshaId !== '') {
                this.viewsData.vwCD2plmd00105_2.jininId = this.inputData.vwCD2plmd00100[0].dojoshaId
              }
              var diffMin = d2dt.calcDiffMinByYmdHms(this.viewsData.vwCD2plmd00104.jissekiShukkoYmd, this.viewsData.vwCD2plmd00104.jissekiShukkoHms, this.viewsData.vwCD2plmd00104.jissekiKikoYmd, this.viewsData.vwCD2plmd00104.jissekiKikoHms)
              if (diffMin !== '') {
                if ((this.viewsData.vwCD2plmd00105_1.jininId)) {
                  this.$set(this.viewsData.vwCD2plmd00105_1, 'kosokuJikan', filter.minToIntervalTimeFormatter(diffMin))
                }
                if ((this.viewsData.vwCD2plmd00105_2.jininId) && this.viewsData.vwCD2plmd00105_2.jininId !== '') {
                  this.$set(this.viewsData.vwCD2plmd00105_2, 'kosokuJikan', filter.minToIntervalTimeFormatter(diffMin))
                }
              }
            } else {
              this.viewsData.vwCD2plmd00104.jissekiShukkoYmd = filter.dateFormatter(this.viewsData.vwCD2plmd00104.jissekiShukkoYmd)
              this.viewsData.vwCD2plmd00104.jissekiShukkoHms = complements.parseTime(this.viewsData.vwCD2plmd00104.jissekiShukkoHms, false).substr(0, 5)
              this.viewsData.vwCD2plmd00104.jissekiKikoYmd = filter.dateFormatter(this.viewsData.vwCD2plmd00104.jissekiKikoYmd)
              this.viewsData.vwCD2plmd00104.jissekiKikoHms = complements.parseTime(this.viewsData.vwCD2plmd00104.jissekiKikoHms, false).substr(0, 5)
              if ((this.viewsData.vwCD2plmd00105_1.jininId)) {
                this.viewsData.vwCD2plmd00105_1.kosokuJikan = filter.minToIntervalTimeFormatter(this.viewsData.vwCD2plmd00105_1.kosokuJikan)
              }
              if ((this.viewsData.vwCD2plmd00105_2.jininId) && this.viewsData.vwCD2plmd00105_2.jininId !== '') {
                this.viewsData.vwCD2plmd00105_2.kosokuJikan = filter.minToIntervalTimeFormatter(this.viewsData.vwCD2plmd00105_2.kosokuJikan)
              }
            }
            this.viewsData.vwCD2plmd00104.sharyoId = this.inputData.vwCD2plmd00100[0].sharyoId
            if (this.inputData.vwCD2plmd00100[0].sharyoId) {
              // 車両マスタより配車区分取得
              var mstSharyo = indexeddb.getRecord(this.sharyoList, this.inputData.vwCD2plmd00100[0].sharyoId)
              if (mstSharyo) {
                this.viewsData.vwCD2plmd00104.sharyoNo = mstSharyo.sharyoNo
                this.viewsData.vwCD2plmd00104.shashuSbt = mstSharyo.shashuSbt
                if (mstSharyo.hacchusakiFlg) {
                  this.sharyoKbn = '03'
                } else {
                  this.sharyoKbn = '01'
                }
                this.viewsData.vwCD2plmd00104.haishaKbn = this.sharyoKbn
              }
            }
            if (this.viewsData.vwCD2plmd00104.id < 0) {
              const self = this
              this.inputData.vwCD2plmd00101.forEach(function (item) {
                if (item.sagyoYmd === self.viewsData.vwCD2plmd00104.unkoYmd) {
                  var recVwCD2plmd00106 = {
                    kaishaCd: item.kaishaCd,
                    id: -1,
                    trJuchuKihonId: item.trJuchuKihonId,
                    juchuNo: item.juchuNo,
                    juchuEigyoshoId: item.juchuEigyoshoId,
                    tokuisakiId: item.ninushiId,
                    trJuchuKihonUpdDate: item.trJuchuKihonUpdDate,
                    trJuchuMeisaiId: item.trJuchuMeisaiId,
                    juchuMeisaiNo: item.juchuMeisaiNo,
                    ninushiId: item.ninushiId,
                    hatsuchiId: item.hatsuchiId,
                    hatsuchiBiko: item.hatsuchiBiko,
                    hatsuchiYmd: item.hatsuchiYmd,
                    hatsuchiHms: item.hatsuchiHms,
                    hatsuchiHmsBiko: item.hatsuchiHmsBiko,
                    chakuchiId: item.chakuchiId,
                    chakuchiBiko: item.chakuchiBiko,
                    chakuchiYmd: item.chakuchiYmd,
                    chakuchiHms: item.chakuchiHms,
                    chakuchiHmsBiko: item.chakuchiHmsBiko,
                    uriageBunruiSbt: item.uriageBunruiSbt,
                    seikyuYoteiYmd: item.seikyuYoteiYmd,
                    trJuchuMeisaiUpdDate: item.trJuchuMeisaiUpdDate,
                    trJuchuKingakuId: item.trJuchuKingakuId,
                    trJuchuMeisaiKingakuUpdDate: item.trJuchuMeisaiKingakuUpdDate,
                    seikyuKihonUnchin: item.kihonUnchin,
                    seikyuHiwayPrice: item.hiwayPrice,
                    seikyuUserKingakuKazei1: item.userKingakuKazei1,
                    seikyuUserKingakuKazei2: item.userKingakuKazei2,
                    seikyuUserKingakuKazei3: item.userKingakuKazei3,
                    sagyoinTeateKingaku1: item.sagyoinTeateKingaku1,
                    sagyoinTeateKingaku2: item.sagyoinTeateKingaku2,
                    shiharaiKihonUnchin: item.shiharaiKihonUnchin,
                    shiharaiHiwayPrice: item.shiharaiHiwayPrice,
                    shiharaiUserKingakuKazei1: item.shiharaiUserKingakuKazei1,
                    shiharaiUserKingakuKazei2: item.shiharaiUserKingakuKazei2,
                    trSagyoMeisaiId: item.id,
                    sagyoEigyoshoId: item.sagyoEigyoshoId,
                    trSagyoMeisaiUpdDate: item.trSagyoMeisaiUpdDate,
                    trSagyoMeisaiKingakuUpdDate: item.trSagyoMeisaiKingakuUpdDate,
                    trJuhacchusagyoRelationId: item.trJuhacchusagyoRelationId,
                    trJuhacchusagyoRelationUpdDate: item.trJuhacchusagyoRelationUpdDate
                  }

                  if (self.viewsData.vwCD2plmd00106.length > 0) {
                    self.viewsData.vwCD2plmd00106.push(recVwCD2plmd00106)
                  } else {
                    self.viewsData.vwCD2plmd00106 = [recVwCD2plmd00106]
                  }
                }
              })
              // 作業情報
              this.inputData.vwCD2plmd00102.forEach(function (item) {
                if (item.sagyoYmd === self.viewsData.vwCD2plmd00104.unkoYmd) {
                  var recVwCD2plmd00106 = {
                    kaishaCd: item.kaishaCd,
                    id: -1,
                    trJuchuKihonId: null,
                    juchuNo: item.sagyoMeisaiBiko,
                    juchuEigyoshoId: item.sagyoEigyoshoId,
                    tokuisakiId: null,
                    trJuchuKihonUpdDate: null,
                    trJuchuMeisaiId: null,
                    juchuMeisaiNo: null,
                    ninushiId: null,
                    hatsuchiId: null,
                    hatsuchiBiko: null,
                    hatsuchiYmd: item.startYmd,
                    hatsuchiHms: item.startHms,
                    hatsuchiHmsBiko: null,
                    chakuchiId: null,
                    chakuchiBiko: '',
                    chakuchiYmd: item.endYmd,
                    chakuchiHms: item.endHms,
                    chakuchiHmsBiko: null,
                    uriageBunruiSbt: null,
                    seikyuYoteiYmd: null,
                    trJuchuMeisaiUpdDate: null,
                    trJuchuKingakuId: null,
                    trJuchuMeisaiKingakuUpdDate: null,
                    seikyuKihonUnchin: '',
                    seikyuHiwayPrice: '',
                    seikyuUserKingakuKazei1: '',
                    seikyuUserKingakuKazei2: '',
                    seikyuUserKingakuKazei3: '',
                    sagyoinTeateKingaku1: '',
                    sagyoinTeateKingaku2: '',
                    shiharaiKihonUnchin: '',
                    shiharaiHiwayPrice: '',
                    shiharaiUserKingakuKazei1: '',
                    shiharaiUserKingakuKazei2: '',
                    trSagyoMeisaiId: item.id,
                    sagyoEigyoshoId: item.sagyoEigyoshoId,
                    trSagyoMeisaiUpdDate: item.trSagyoMeisaiUpdDate,
                    trSagyoMeisaiKingakuUpdDate: null,
                    trJuhacchusagyoRelationId: item.trJuhacchusagyoRelationId,
                    trJuhacchusagyoRelationUpdDate: item.trJuhacchusagyoRelationUpdDate
                  }

                  if (self.viewsData.vwCD2plmd00106.length > 0) {
                    self.viewsData.vwCD2plmd00106.push(recVwCD2plmd00106)
                  } else {
                    self.viewsData.vwCD2plmd00106 = [recVwCD2plmd00106]
                  }
                }
              })
            }
          })
        }
      }
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onCloseClick: function (e) {
      this.$emit('close', undefined)
    },
    // --------------------------------------------------------------------------------
    // キャンセルボタン押下
    // --------------------------------------------------------------------------------
    onCancelClick: function (e) {
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.Effects.loadStart()
        this.initBindVariables()
        this.Effects.loadComplete()
      })
    },
    // --------------------------------------------------------------------------------
    // 削除ボタン押下
    // --------------------------------------------------------------------------------
    onDeleteClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            var ifData = self.viewsData
            // DB処理用変換
            if (ifData.vwCD2plmd00105_1.kosokuJikan && ifData.vwCD2plmd00105_1.kosokuJikan !== '') {
              ifData.vwCD2plmd00105_1.kosokuJikan = filter.timeToMinFormatter(ifData.vwCD2plmd00105_1.kosokuJikan)
            }
            if (ifData.vwCD2plmd00105_2.kosokuJikan && ifData.vwCD2plmd00105_2.kosokuJikan !== '') {
              ifData.vwCD2plmd00105_2.kosokuJikan = filter.timeToMinFormatter(ifData.vwCD2plmd00105_2.kosokuJikan)
            }
            self.HttpClient.post('/api/v1/VwCD2plmd00103/Delete', ifData).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        },
        isInvokeCallbackOnSuccess: function () {
          return true
        },
        onSuccessCallback: function () {
          return new Promise(resolve => {
            self.inputData.vwCD2plmd00100.forEach((x) => {
              x.jissekiKakuninZumiFlg = false
              x.updateFlg = true
              x.jissekiStatus = '0'
            })
            self.inputData.vwCD2plmd00101.forEach(function (item) {
              if (item.sagyoYmd === self.viewsData.vwCD2plmd00104.unkoYmd) {
                item.jissekiKakuninZumiFlg = false
              }
            })
            self.$emit('save', self.inputData)
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    // --------------------------------------------------------------------------------
    // 保存ボタン押下
    // --------------------------------------------------------------------------------
    onSaveClick: function (e) {
      this.onSaveAction()
    },
    onSaveAction: function () {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.viewsData.vwCD2plmd00104.unkoJissekiNo = data.payload.vwCD2Plmd00104.unkoJissekiNo
            self.inputData.vwCD2plmd00100.forEach((x) => {
              x.jissekiKakuninZumiFlg = self.viewsData.vwCD2plmd00104.jissekiKakuninZumiFlg
              x.jissekiStatus = self.viewsData.vwCD2plmd00104.jissekiKakuninZumiFlg ? '9' : '1'
            })
            self.inputData.vwCD2plmd00101.forEach(function (item) {
              if (item.sagyoYmd === self.viewsData.vwCD2plmd00104.unkoYmd) {
                data.payload.vwCD2Plmd00106.forEach((p) => {
                  if (item.id === p.trSagyoMeisaiId) {
                    item.kakuteiFlg = true
                    item.trJuchuKihonUpdDate = p.trJuchuKihonUpdDate
                    item.trJuchuMeisaiUpdDate = p.trJuchuMeisaiUpdDate
                    item.trJuchuMeisaiKingakuUpdDate = p.trJuchuMeisaiKingakuUpdDate
                    item.trSagyoMeisaiUpdDate = p.trSagyoMeisaiUpdDate
                    item.trSagyoMeisaiKingakuUpdDate = p.trSagyoMeisaiKingakuUpdDate
                    item.trJuhacchusagyoRelationUpdDate = p.trJuhacchusagyoRelationUpdDate
                  }
                })
                item.jissekiKakuninZumiFlg = true
              }
            })
            self.$emit('save', self.inputData)
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      var ifData = this.viewsData
      // DB処理用変換
      if (ifData.vwCD2plmd00105_1.kosokuJikan && ifData.vwCD2plmd00105_1.kosokuJikan !== '') {
        ifData.vwCD2plmd00105_1.kosokuJikan = filter.timeToMinFormatter(ifData.vwCD2plmd00105_1.kosokuJikan)
      }
      if (ifData.vwCD2plmd00105_2.kosokuJikan && ifData.vwCD2plmd00105_2.kosokuJikan !== '') {
        ifData.vwCD2plmd00105_2.kosokuJikan = filter.timeToMinFormatter(ifData.vwCD2plmd00105_2.kosokuJikan)
      }

      const f = this.HttpClient.post('/api/v1/VwCD2plmd00103/Register', ifData)
      return f
    },
    registerValidate: function () {
      if (this.sharyoKbn === '01') {
        if (this.calcShiharaiTotalAmount() > 0) {
          modals.showError('支払金額が入力されています。入力を見直して下さい。')
          return false
        }
      } else if (this.sharyoKbn === '03') {
        if (this.calcTeateTotalAmount() > 0) {
          modals.showError('手当金額が入力されています。入力を見直して下さい。')
          return false
        }
      }

      return true
    },
    // --------------------------------------------------------------------------------
    // データテーブルエリア編集制御
    // --------------------------------------------------------------------------------
    seikyuYoteiYmdSaved (e, row) {
      if (!e) { return false }
      row.seikyuYoteiYmd = e
    },
    seikyuKihonUnchinSaved (e, row) {
      if (!e) {
        row.seikyuKihonUnchin = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.seikyuKihonUnchin = filter.numericFormatter(val)
    },
    seikyuHiwayPriceSaved (e, row) {
      if (!e) {
        row.seikyuHiwayPrice = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.seikyuHiwayPrice = filter.numericFormatter(val)
    },
    seikyuUserKingakuKazei1Saved (e, row) {
      if (!e) {
        row.seikyuUserKingakuKazei1 = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.seikyuUserKingakuKazei1 = filter.numericFormatter(val)
    },
    seikyuUserKingakuKazei2Saved (e, row) {
      if (!e) {
        row.seikyuUserKingakuKazei2 = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.seikyuUserKingakuKazei2 = filter.numericFormatter(val)
    },
    sagyoinTeateKingaku1Saved (e, row) {
      if (!e) {
        row.sagyoinTeateKingaku1 = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.sagyoinTeateKingaku1 = filter.numericFormatter(val)
    },
    sagyoinTeateKingaku2Saved (e, row) {
      if (!e) {
        row.sagyoinTeateKingaku2 = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.sagyoinTeateKingaku2 = filter.numericFormatter(val)
    },
    shiharaiKihonUnchinSaved (e, row) {
      if (!e) {
        row.shiharaiKihonUnchin = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.shiharaiKihonUnchin = filter.numericFormatter(val)
    },
    shiharaiYoteiYmdSaved (e, row) {
      if (!e) { return false }
      row.shiharaiYoteiYmd = e
    },
    shiharaiHiwayPriceSaved (e, row) {
      if (!e) {
        row.shiharaiHiwayPrice = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.shiharaiHiwayPrice = filter.numericFormatter(val)
    },
    shiharaiUserKingakuKazei1Saved (e, row) {
      if (!e) {
        row.shiharaiUserKingakuKazei1 = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.shiharaiUserKingakuKazei1 = filter.numericFormatter(val)
    },
    shiharaiUserKingakuKazei2Saved (e, row) {
      if (!e) {
        row.shiharaiUserKingakuKazei2 = ''
        return false
      }
      const val = d2fmt.removeComma(e)
      if (!window.isFinite(val)) { return }
      row.shiharaiUserKingakuKazei2 = filter.numericFormatter(val)
    },
    // --------------------------------------------------------------------------------
    // その他共通
    // --------------------------------------------------------------------------------
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 手当合計計算
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    calcTeateTotalAmount: function () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmount = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        m.CalcSagyoinTeateKingaku1 = window.isFinite(d2fmt.removeComma(m.sagyoinTeateKingaku1)) ? parseInt(d2fmt.removeComma(m.sagyoinTeateKingaku1), 10) : 0
        m.CalcSagyoinTeateKingaku2 = window.isFinite(d2fmt.removeComma(m.sagyoinTeateKingaku2)) ? parseInt(d2fmt.removeComma(m.sagyoinTeateKingaku2), 10) : 0
        return m.CalcSagyoinTeateKingaku1 + m.CalcSagyoinTeateKingaku2
      }).forEach(x => {
        totalAmount += x
      })

      return totalAmount
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 支払合計計算
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    calcShiharaiTotalAmount: function () {
      // レコード存在時のみ実施
      if (this.viewsData.vwCD2plmd00106 === undefined) { return 0 }
      if (this.viewsData.vwCD2plmd00106.length === 0) { return 0 }

      let totalAmount = 0

      this.viewsData.vwCD2plmd00106.map((m) => {
        m.CalcShiharaiKihonUnchin = window.isFinite(d2fmt.removeComma(m.shiharaiKihonUnchin)) ? parseInt(d2fmt.removeComma(m.shiharaiKihonUnchin), 10) : 0
        m.CalcShiharaiHiwayPrice = window.isFinite(d2fmt.removeComma(m.shiharaiHiwayPrice)) ? parseInt(d2fmt.removeComma(m.shiharaiHiwayPrice), 10) : 0
        m.CalcShiharaiUserKingakuKazei1 = window.isFinite(d2fmt.removeComma(m.shiharaiUserKingakuKazei1)) ? parseInt(d2fmt.removeComma(m.shiharaiUserKingakuKazei1), 10) : 0
        m.CalcShiharaiUserKingakuKazei2 = window.isFinite(d2fmt.removeComma(m.shiharaiUserKingakuKazei2)) ? parseInt(d2fmt.removeComma(m.shiharaiUserKingakuKazei2), 10) : 0
        return m.CalcShiharaiKihonUnchin + m.CalcShiharaiHiwayPrice + m.CalcShiharaiUserKingakuKazei1 + m.CalcShiharaiUserKingakuKazei2
      }).forEach(x => {
        totalAmount += x
      })

      return totalAmount
    },
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    // * 時間計算
    // * ToとFromの差を分で返す
    // ++++++++++++++++++++++++++++++++++++++++++++++++++
    calcJomuinKosokuJikan: function () {
      var msg
      if (this.viewsData.vwCD2plmd00104.jissekiShukkoYmd && this.viewsData.vwCD2plmd00104.jissekiKikoYmd) {
        msg = validators.compareDate(this.viewsData.vwCD2plmd00104.jissekiShukkoYmd, this.viewsData.vwCD2plmd00104.jissekiKikoYmd)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.viewsData.vwCD2plmd00104.jissekiShukkoYmd && this.viewsData.vwCD2plmd00104.jissekiShukkoHms && this.viewsData.vwCD2plmd00104.jissekiKikoYmd && this.viewsData.vwCD2plmd00104.jissekiKikoHms) {
        msg = validators.compareDateTime(this.viewsData.vwCD2plmd00104.jissekiShukkoYmd, this.viewsData.vwCD2plmd00104.jissekiShukkoHms, this.viewsData.vwCD2plmd00104.jissekiKikoYmd, this.viewsData.vwCD2plmd00104.jissekiKikoHms)
        if (msg !== undefined) {
          this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      var diffMin = d2dt.calcDiffMinByYmdHms(this.viewsData.vwCD2plmd00104.jissekiShukkoYmd, this.viewsData.vwCD2plmd00104.jissekiShukkoHms, this.viewsData.vwCD2plmd00104.jissekiKikoYmd, this.viewsData.vwCD2plmd00104.jissekiKikoHms)
      if (diffMin !== '') {
        this.$set(this.viewsData.vwCD2plmd00105_1, 'kosokuJikan', filter.minToIntervalTimeFormatter(diffMin))
        if ((this.viewsData.vwCD2plmd00105_2.jininId) && this.viewsData.vwCD2plmd00105_2.jininId !== '') {
          this.$set(this.viewsData.vwCD2plmd00105_2, 'kosokuJikan', filter.minToIntervalTimeFormatter(diffMin))
        }
      }
      this.$refs.jissekiShukkoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.jissekiShukkoHms[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.jissekiKikoYmd[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.jissekiKikoHms[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.kosokuJikan1[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.kosokuJikan2[this.Ctrls.SET_INVALID_METHOD](undefined)

      return true
    }
  }
}
